import { Font, PDFViewer, pdf, Document, Text, Page, Image, View, StyleSheet } from '@react-pdf/renderer'
import fonts from '../../../config/fonts';
import { grey, accentColor, loginBGImage, cdfontFamily, cdtextcolor, navbarcolor, 
        navbartextcolor, pagesbgcolor, black, white, blue, reportBoyMid} 
        from '../../../config/Colors';

// Register asynchronously loaded fonts before rendering anything.
//fonts.map((font) => Font.register({ family: font.name, src: font.url }))

// Font.register({
//     family: 'Lato sans-serif',
//     src: 'https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh50XSwiPGQ3q5d0.woff2',
// });

// Font.register({
//     family: 'Lato Italic',
//     src: 'https://fonts.gstatic.com/s/lato/v24/S6u_w4BMUTPHjxsI3wi_FQftx9897sxZ.woff2',
// });


const reportStyles = StyleSheet.create({
    page: {
      //fontFamily: 'Lato Regular',
      display: 'flex',
      flexDirection: 'column',
      //flexGrow: 1,
      fontSize: 20,
      //padding: 10,
    },
    heading: {
      //fontFamily: 'Lato Bold',ß
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: 10,
      marginBottom: 10,
      backgroundColor: '#FFFFFF',
    },
    headings: {
      flexShrink: 1,
      marginRight: 10,
      flexDirection: 'column',
      flexWrap: 'wrap',
      width: 320,
    },
    title: {
      marginBottom: 10,
      fontSize: 36,
      color:'#FFFFFF'
    },
    title1: {
      marginBottom: 10,
      fontSize: 14,
      color:'#FFFFFF'
    },
    title2: {
        marginBottom: 10,
        fontSize: 16,
        color:'#FFFFFF'
    },
    title3: {
        marginBottom: 5,
        fontSize: 12,
        color:'#FFFFFF',
        fontStyle:'italic',
        fontWeight:'300',
    },
    titleBlack: {
        marginBottom: 10,
        fontSize: 36,
        color:black
      },
    title1Black: {
        marginBottom: 10,
        fontSize: 14,
        color:black
    },
    title2Black: {
        marginBottom: 10,
        fontSize: 16,
        color:black
    },
    title3Black: {
        marginBottom: 5,
        fontSize: 12,
        color:black,
        fontStyle:'italic',
        fontWeight:'300',
    },
    titleWhite: {
        marginBottom: 10,
        fontSize: 36,
        color:white
      },
    title1White: {
        marginBottom: 10,
        fontSize: 14,
        color:white
    },
    title2White: {
        marginBottom: 10,
        fontSize: 16,
        color:white
    },
    title3White: {
        marginBottom: 5,
        fontSize: 12,
        color:white,
        fontStyle:'italic',
        fontWeight:'300',
    },
    subtitle: {
      color: '#000000',
      marginBottom: '5px',
      marginTop: '5px',
      fontSize: 18,
    },
    PageTitle: {
        marginBottom: '5px',
        marginTop: '5px',
        fontSize: 16,
        color:'#FFFFFF'
    },
    PageSubTitle: {
        marginBottom: '5px',
        marginTop: '5px',
        fontSize: 14,
        color:'#000000'
    },
    PageText: {
        marginBottom: '5px',
        marginTop: '5px',
        fontSize: 12,
        color:'#000000'
    },
    description: {
        fontSize: 10,
        color:'#000000'
    },
    PageTextSmall: {
        // marginBottom: '5px',
        // marginTop: '5px',
        fontSize: 10,
        color:'#000000'
    },
    descriptionSmall: {
        fontSize: 8,
        color:'#000000'
    },
    image: {
        minHeight: "75vh",
        minWidth: "75vh",   
    },
    headerImage: {
        minHeight: "15vh",
        minWidth: "15vh",   
    },
    footer: {
      fontSize: 10,
      fontStyle:"italic"
    },
    fonts: {
      marginBottom: 10,
    },
    font: {
      small: {
        paddingBottom: 5,
        fontFamily: 'Lato Regular',
        fontSize: 10,
      },
      latoRegular: {
        paddingBottom: 10,
        fontFamily: 'Helvetica',
      },
      latoBold: {
        fontFamily: 'Alice',
      },
      latoItalic: {
        fontFamily: 'Inter UI',
      },
      latoBlack: {
        fontFamily: 'Roboto',
      },
    },
    MainBGDivNoAlign: {
        backgroundColor:pagesbgcolor,
        width: "100%",
        height: "100vh",
        minHeight: "100vh",
        minWidth: "100vh",      
    },
    FirstPage: {
        //padding: "5",
        //flex:"1",
        // backgroundImage: `url(${process.env.PUBLIC_URL + reportBoyMid})`,
        // backgroundSize: "cover",
        // backgroundRepeat: "no-repeat",
        // backgroundPosition: "top"
    },
    Container: { 
        //padding: "60",
        flex: "1",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        //fontFamily: cdfontFamily,
        backgroundColor: '#000000',
    },
    FirstPageHeaderContainer: { 
        //padding: "60",
        flex: "1",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        //fontFamily: cdfontFamily,
        backgroundColor: white,
    },
    HeaderContainer: { 
        //flex: "1",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        backgroundColor: navbarcolor,
    },
    FooterContainer: { 
        padding: "10px 15px 40px 25px", 
        //flex: "1",
        flexDirection: "column",
        justifyContent: "flex-end",
        alignItems: "center",
        backgroundColor: pagesbgcolor,
    },
    FooterContainerSmall: { 
        padding: "5px 5px 5px 5px", 
        //flex: "1",
        flexDirection: "column",
        justifyContent: "flex-end",
        alignItems: "center",
        backgroundColor: pagesbgcolor,
    },
    BottomContainerStart: { 
        padding: "20px 25px", 
        //marginBottom: 10,
        flex: "1",
        flexDirection: "column",
        justifyContent: "flex-end",
        //alignItems: "left",
        //fontFamily: cdfontFamily,
        // width: "98%",
        //height: "70px",
        //minHeight: "70px",
        //backgroundColor: '#E4E4E4',
    },
    FirstPageMainContainer: { 
        padding: "200px 25px 5px 25px", 
        flex: "1",
        flexDirection: "column",
        justifyContent: "flex-end",
    },
    CenterContainerStart: { 
        padding: "20px 25px", 
        flex: "1",
        flexDirection: "column",
        justifyContent: "flex-center",
        alignItems: "center",
    },
    BottomContainerLeft: { 
        padding: "5px 5px", 
        flex: "1",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "left",
        fontFamily: cdfontFamily,
    },
    BottomContainer: { 
        padding: "10px 15px 40px 25px", 
        flex: "1",
        flexDirection: "column",
        justifyContent: "flex-end",
        alignItems: "left",
        //fontFamily: cdfontFamily,
    },     
    table: {
        flexDirection: 'column',
        //flexGrow: 1,
    },
    row: {
        flexDirection: 'row',
    },
    rowCenter: {
        flexDirection: 'row',
        justifyContent: "center",
    },
    rowStart: {
        flexDirection: 'row',
        justifyContent: "flex-start",
        padding: "10px 10px 40px 10px", 
        backgroundColor: pagesbgcolor,
    },
    rowPageSubHeader: {
        flexDirection: 'row',
        justifyContent: "flex-start",
        //padding: "5px 5px 5px 5px", 
        backgroundColor: pagesbgcolor,
    },
    rowPageSubHeaderNBG: {
        flexDirection: 'row',
        justifyContent: "flex-start",
        //padding: "5px 5px 5px 5px", 
        //backgroundColor: pagesbgcolor,
    },
    rowStartSmall: {
        flexDirection: 'row',
        justifyContent: "flex-start",
        padding: "5px 5px 5px 5px", 
        backgroundColor: pagesbgcolor,
    },
    header: {
        //flexGrow: 1,
        paddingTop: 12,
        paddingBottom: 5,
        borderBottomWidth: 0.5,
        borderColor: '#000000',
    },
    cell: {
        //flexGrow: 1,
        paddingTop: 12,
        paddingBottom: 5,
        borderBottomWidth: 1,
        borderRightWidth: 1,
        borderColor: grey,
    },           
    cellNB: {
        //flexGrow: 1,
        paddingTop: 12,
        paddingBottom: 5,
    },           
    cell25: {
        width:'25%',
        paddingTop: 5,
        paddingBottom: 5,
        borderBottomWidth: 1,
        borderRightWidth: 1,
        borderColor: grey,
        alignItems:'center',
    },           
    cell25BB: {
        width:'25%',
        paddingTop: 5,
        paddingBottom: 5,
        borderBottomWidth: 1,
        borderColor: grey,
        alignItems:'center',
    },           
    cell50: {
        //flexGrow: 1,
        width:'50%',
        paddingTop: 12,
        paddingBottom: 5,
        borderBottomWidth: 1,
        borderRightWidth: 1,
        borderColor: grey,
        alignItems:'center',
    },           
    cell50BB: {
        //flexGrow: 1,
        width:'50%',
        paddingTop: 12,
        paddingBottom: 5,
        borderBottomWidth: 1,
        borderColor: grey,
        alignItems:'center',
    },           
    cell50NB: {
        //flexGrow: 1,
        width:'50%',
        paddingTop: 12,
        paddingBottom: 5,
        //borderBottomWidth: 1,
        //borderColor: grey,
        alignItems:'center',
    },           
    cell50NBLeft: {
        //flexGrow: 1,
        width:'50%',
        paddingTop: 5,
        paddingBottom: 5,
        paddingLeft: 10,
        //borderBottomWidth: 1,
        //borderColor: grey,
        alignItems:'left',
    },           
    cell50BG: {
        //flexGrow: 1,
        width:'50%',
        paddingTop: 12,
        paddingBottom: 5,
        borderBottomWidth: 1,
        borderRightWidth: 1,
        borderColor: grey,
        //backgroundColor: '#E4E4E4',
        alignItems: "left",
    },           
    cell33RB: {
        width:'33%',
        paddingTop: 5,
        paddingRight: 5,
        borderRightWidth: 1,
        borderColor: grey,
        alignItems:'center',
    },           
    cell33NB: {
        width:'33%',
        paddingTop: 5,
        alignItems:'center',
    },           
    cell33BB: {
        width:'33%',
        paddingTop: 5,
        paddingBottom: 5,
        borderBottomWidth: 1,
        borderColor: grey,
        alignItems:'center',
    },           
    cell80NB: {
        width:'33%',
        paddingTop: 12,
        paddingBottom: 5,
        alignItems:'center',
    },           
    cell40: {
        //flexGrow: 1,
        width:'40%',
        paddingTop: 12,
        paddingBottom: 5,
        // borderBottomWidth: 1,
        // borderRightWidth: 1,
        // borderColor: grey,
        alignItems:'center',
    },           
    cell40BB: {
        //flexGrow: 1,
        width:'40%',
        paddingTop: 12,
        paddingBottom: 5,
        borderBottomWidth: 1,
        // borderRightWidth: 1,
        borderColor: grey,
        alignItems:'center',
    },           
    cell40NB: {
        //flexGrow: 1,
        width:'40%',
        paddingTop: 12,
        paddingBottom: 5,
        //borderBottomWidth: 1,
        // borderRightWidth: 1,
        //borderColor: grey,
        alignItems:'center',
    },         
    cell40NB: {
        //flexGrow: 1,
        width:'40%',
        paddingTop: 12,
        paddingBottom: 5,
        //borderBottomWidth: 1,
        // borderRightWidth: 1,
        //borderColor: grey,
        alignItems:'left',
    },               
    cell40NBLeft: {
        //flexGrow: 1,
        width:'40%',
        paddingTop: 12,
        paddingBottom: 5,
        //borderBottomWidth: 1,
        // borderRightWidth: 1,
        //borderColor: grey,
        alignItems:'left',
    },     
    cell60NBLeft: {
        //flexGrow: 1,
        width:'60%',
        paddingTop: 12,
        paddingBottom: 5,
        //borderBottomWidth: 1,
        // borderRightWidth: 1,
        //borderColor: grey,
        alignItems:'left',
    },     
    cell60BB: {
        //flexGrow: 1,
        width:'60%',
        paddingTop: 12,
        paddingBottom: 5,
        borderBottomWidth: 1,
        // borderRightWidth: 1,
        borderColor: grey,
    },           
    cell60NB: {
        //flexGrow: 1,
        width:'60%',
        paddingTop: 12,
        //paddingBottom: 5,
        //borderBottomWidth: 1,
        // borderRightWidth: 1,
        //borderColor: grey,
    },           
    cell60NBNP: {
        width:'60%',
    },           
    cell80BB: {
        width:'80%',
        paddingTop: 5,
        paddingBottom: 5,
        borderBottomWidth: 1,
        borderColor: grey,
    },           
    cell20BB: {
        width:'20%',
        paddingTop: 5,
        paddingBottom: 5,
        borderBottomWidth: 1,
        borderColor: grey,
    },           
    cell100NB: {
        width:'100%',
        paddingTop: 12,
    },           
    cell20: {
        //flexGrow: 1,
        width:'20%',
        paddingTop: 12,
        paddingBottom: 5,
        // borderBottomWidth: 1,
        // borderRightWidth: 1,
        // borderColor: grey,
    },          
    cell10: {
        width:'10%',
        paddingTop: 12,
        paddingBottom: 5,
    },          
    cell10NB: {
        width:'10%',
        paddingTop: 5,
        paddingBottom: 5,
    },          
    cell10NBNP: {
        width:'10%',
    },          
    cell90NB: {
        width:'90%',
        paddingTop: 5,
        paddingBottom: 5,
    },          
    imageIndCell: {
        padding: "5px 5px 5px 5px", 
        width:"120px",
        height: "22px",
    },     
    imageIndCenterCell: {
        padding: "5px 5px 5px 5px", 
        width:"120px",
        height: "22px",
        alignSelf:'center',
    },     
    image100Cell: {
        padding: "10px 10px 10px 10px", 
        alignSelf:'center',
        width:"100px",
        height: "100px",
    },     
    image150x75Cell: {
        padding: "10px 10px 10px 10px", 
        alignSelf:'center',
        width:"150px",
        height: "75px",
    },     
    image415x17Cell: {
        padding: "10px 10px 10px 10px", 
        alignSelf:'center',
        width:"260px",
        height: "35px",
    },     
    imageWellnessBarCell: {
        alignSelf:'center',
        width:"260px",
        height: "35px",
    },     
    image27x49Cell: {
        padding: "10px 10px 10px 10px", 
        alignSelf:'center',
        width:"27px",
        height: "49px",
    },     
    image70x70Cell: {
        padding: "5px 5px 5px 5px", 
        alignSelf:'center',
        width:"70px",
        height: "70px",
    },     
    image50x50Cell: {
        padding: "5px 5px 5px 5px", 
        alignSelf:'center',
        width:"50px",
        height: "50px",
    },     
    image40x40Cell: {
        padding: "5px 5px 5px 5px", 
        alignSelf:'center',
        width:"40px",
        height: "40px",
    },     
    image33Cell: {
        padding: "10px 10px 10px 10px", 
        alignSelf:'center',
        width:"33px",
        height: "33px",
        //backgroundColor: pagesbgcolor,
    },     
    image22Cell: {
        padding: "5px 5px 5px 5px", 
        alignSelf:'center',
        width:"22px",
        height: "22px",
        //backgroundColor: pagesbgcolor,
    },     
    image186Cell: {
        padding: "10px 10px 10px 10px", 
        alignSelf:'center',
        width:"186px",
        height: "186px",
        //backgroundColor: pagesbgcolor,
    },     
    image20Cell: {
        padding: "10px 10px 10px 10px", 
        alignSelf:'center',
        width:"20px",
        height: "20px",
        //backgroundColor: pagesbgcolor,
    },     
  })
  
  export default reportStyles